import React from 'react'
import { RecommendedOption } from '../step-selector'
import { formatStyles } from '../../../../react-intl-helpers'
import { getLanguageInfo } from '../common/utils'
import { StepKubernetesDownloadSetup } from './step-kubernetes-download-setup'

const stepSelectKubernetesOperator = {
  defaultIsOpen: true,
  titleMsg: 'title_selectMethodToConfigureAgentOperator',
  Content: {
    postDetailMsg: {
      message: 'detail_selectMethodToConfigureAgentOperator',
      values: formatStyles.link({
        isExternal: true,
        href: 'https://helm.sh/docs/intro/install/'
      })
    },
    options: [
      {
        value: 'helm',
        Content: <RecommendedOption Content="Helm charts" />
      },
      { value: 'manifest', Content: 'Manifest' }
    ]
  }
  // requires branchKey, branchOptions
}

const stepKubernetesLabelDeployments = (language) => {
  const languageInfo = getLanguageInfo(language)
  return {
    titleMsg: 'title_labelDeployments',
    Content: {
      message: 'detail_labelDeployments',
      values: {
        language: languageInfo?.agentId,
        code: `NAME               READY     UP-TO-DATE     AVAILABLE     AGE
app1-deployment    0/3       0              0             15`
      }
    }
  }
}

const stepKubernetesDownloadSetup = {
  defaultIsOpen: true,
  titleMsg: 'title_downloadAndSetupTheValuesFile',
  Content: () => <StepKubernetesDownloadSetup />
}

const stepKubernetesInstallDeployHelm = {
  titleMsg: 'title_installAndDeployHelmChart',
  Content: {
    message: 'detail_installAndDeployHelmChart',
    values: {
      code: `helm repo add contrast https://contrastsecurity.dev/helm-charts
helm repo update contrast
helm upgrade --install --namespace contrast-agent-operator --create-namespace -f contrast-agent-operator.yaml contrast-agent-operator contrast/contrast-agent-operator`
    }
  }
}

export {
  stepSelectKubernetesOperator,
  stepKubernetesDownloadSetup,
  stepKubernetesLabelDeployments,
  stepKubernetesInstallDeployHelm
}
